import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-64" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "h4 title fw-normal mb-72 text-primary" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "form mb-48" }
const _hoisted_6 = { class: "row gx-32" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "selected" }
const _hoisted_11 = {
  ref: "load",
  class: "create-category"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add me-16 text-sm"
}, null, -1)
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "form-actions text-end" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-add fw-bold text-sm me-8"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_form_group_textarea = _resolveComponent("v-form-group-textarea")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_the_admin_video_category_create = _resolveComponent("the-admin-video-category-create")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('Añadir')) + " ", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('nuevo vídeo')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_form_group_input_text, {
              label: _ctx.$t('Nombre'),
              value: _ctx.name,
              "yup-errors-variable": _ctx.errors.name,
              autocomplete: "off",
              class: "mb-24",
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event))
            }, null, 8, ["label", "value", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_form_group_textarea, {
              label: _ctx.$t('Descripción'),
              value: _ctx.description,
              class: "mb-24",
              idKey: "description",
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.description = $event))
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_form_group_select, {
              label: _ctx.$t('Categorías'),
              "yup-errors-variable": _ctx.errors.categories,
              class: "mb-24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.categories,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categories) = $event)),
                  loading: _ctx.loadingCategories,
                  options: _ctx.categoryOptions,
                  reduce: returnValue => returnValue.id,
                  class: "select-search",
                  multiple: ""
                }, {
                  "no-options": _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                  ]),
                  option: _withCtx((option) => [
                    _createElementVNode("div", null, _toDisplayString(option.attributes?.name), 1)
                  ]),
                  "selected-option": _withCtx((option) => [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(option.attributes?.name), 1)
                  ]),
                  "list-footer": _withCtx(() => [
                    _createElementVNode("li", _hoisted_11, [
                      _createVNode(_component_v_button, {
                        class: "btn-icon h-fit fw-normal shadow-none py-0 px-16",
                        size: "sm",
                        variant: "link",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalToShow = 'the-admin-video-category-create'))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir categoria')), 1)
                        ]),
                        _: 1
                      })
                    ], 512)
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading", "options", "reduce"])
              ]),
              _: 1
            }, 8, ["label", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_form_group_select, {
              label: _ctx.$t('Visibilidad'),
              "yup-errors-variable": _ctx.errors.visibility,
              class: "mb-24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.visibility,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visibility) = $event)),
                  class: _normalizeClass({'is-invalid': !!_ctx.errors.visibility}),
                  clearable: false,
                  options: _ctx.formsSettings.video_visibility_options,
                  reduce: returnValue => returnValue.key,
                  "select-on-key-codes": [188, 13]
                }, {
                  "no-options": _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "options", "reduce"])
              ]),
              _: 1
            }, 8, ["label", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_form_group_input_text, {
              label: _ctx.$t('Url'),
              value: _ctx.url,
              "yup-errors-variable": _ctx.errors.url,
              autocomplete: "off",
              class: "mb-24",
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.url = $event))
            }, null, 8, ["label", "value", "yup-errors-variable"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_v_button, {
          "aria-label": _ctx.$t('Cancelar'),
          class: "me-24",
          variant: "link-secondary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.go(-1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
          ]),
          _: 1
        }, 8, ["aria-label"]),
        _createVNode(_component_v_button, {
          "aria-label": _ctx.$t('Añadir'),
          disabled: !_ctx.meta.valid || _ctx.accepted,
          "is-loading": _ctx.accepted,
          class: "btn-icon",
          variant: "secondary",
          onClick: _ctx.createVideo
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Crear')), 1)
          ]),
          _: 1
        }, 8, ["aria-label", "disabled", "is-loading", "onClick"])
      ])
    ]),
    (_ctx.can('admin.video-category.store') &&
      _ctx.modalToShow === 'the-admin-video-category-create')
      ? (_openBlock(), _createBlock(_component_the_admin_video_category_create, {
          key: 0,
          onClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalToShow = null)),
          onReloadCategories: _ctx.loadCategories
        }, null, 8, ["onReloadCategories"]))
      : _createCommentVNode("", true)
  ]))
}